const UnlockedFeatureText =[
    {feature: "funStuff", 
        text: "This feature allows you to add fun things to your game such as " +
              "a pet, horse, boat and other items."  },
    {feature: "moneyBuilder",
        text: "Saving money is an important part of financial literacy.  If you " +
               "activate this feature, you can begin to save money and watch it grow. " +
               "The first level allows you to create bank savings accounts. " +
               "The second level supports the ability to start a retirement 401(k) savings " +
               "account.  When you earn the third level you can invest money in stocks, " +
               "bonds, index funds and mutual funds.  How cool is that??"},
    {feature: "creditCard",
        text: "Credit cards are almost essential in today's world.  If you " +
              "activate a credit card, then you can charge amounts paid in the " +
              "game to the credit card and pay off the card at the end of the month " +
              "or when you can. The credit card maximum amount will change with each " +
              "level."  },
    {feature: "timeWizard",
        text: "This feature allows you to control the time in the game. " +
              "You can decide how many months pass on each turn.  In addition, you can " +
              "determine how many years you will play before the game ends.  The " +
              "options that you have for each of these change with each level."   },
]

export default UnlockedFeatureText;    